import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaAvatar from './VaAvatar.vue'

export const VaAvatar = withConfigTransport(_VaAvatar)
